<template>
    <component :is="tag">
        <slot
            :step="step"
            :brief="brief"
            :go-next-step="goNextStep"
            :go-previous-step="goPreviousStep"
        />
    </component>
</template>

<script>
    import BaseActivationBriefStepMixin from '../mixins/BaseActivationBriefStepMixin';
    import {NAME_NETWORKS} from '../../../constants/activation-brief-steps';

    export default {
        name:   'ActivationBriefNetworksProvider',
        mixins: [
            BaseActivationBriefStepMixin,
        ],
        computed: {
            step(){
                return this.steps[NAME_NETWORKS];
            },
        },
    };
</script>

<style scoped>
</style>
